import React from "react";

const Rules = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 md:px-10 px-4 gap-5 my-20">
      <div className="flex flex-col items-center gap-3">
        <div>
          <img
            className="w-32"
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F13_Icon1.jpg?alt=media&token=111b682f-f9a5-4793-9808-453511ca018c"
            alt=""
          />
        </div>
        <div>
          <h1 className="text-center text-[23px] font-medium">
            Customer Satisfaction
          </h1>
        </div>
        <div>
          <p className="text-center text-[17px] opacity-75">
            We make sure our products and services meet customers' expectations
            in terms of quality, transparency and coorperation.
          </p>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3">
        <div>
          <img
            className="w-32"
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F14_Icon2.jpg?alt=media&token=ce1baf99-4527-45e3-95b5-efee76826952"
            alt=""
          />
        </div>
        <div>
          <h1 className="text-center text-[23px] font-medium">
            B2B Opportunities
          </h1>
        </div>
        <div>
          <p className="text-center  text-[17px] opacity-75">
            Our B2B channel is aimed to fulfil the needs of our business
            associates and partners to be the most competitive in the market in
            the long run.
          </p>
        </div>
      </div>
      <div className="flex flex-col items-center gap-3">
        <div>
          <img
            className="w-32"
            src="	https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F15_Icon3.jpg?alt=media&token=e9b263f3-782e-4748-b868-7aecaba2afd1"
            alt=""
          />
        </div>
        <div>
          <h1 className="text-center text-[23px] font-medium">
            On-site delivery and assembly
          </h1>
        </div>
        <div>
          <p className="text-center text-[17px] opacity-75">
            Our operation team has more than five years experience in on-site
            delivery and assembly to more than 500 homes nationwide.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Rules;
